var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivatedpincode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 50,
    fill: "url(#paint0_radial_6589_20183)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.7974 38.8146V57.7762H61.274V38.9927C61.274 32.7975 56.2777 27.78 50.1184 27.78C43.9494 27.78 38.9628 32.8074 38.9628 38.9828V57.7663H34.3311V38.8146C34.3114 30.076 41.3575 23 50.0593 23C58.7611 23 65.7974 30.076 65.7974 38.8146Z",
    fill: "#DBDEDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.669 38.8146V57.7762H61.1456V38.9927C61.1456 32.8272 56.1887 27.8196 50.0688 27.7899V23C58.7016 23.0792 65.669 30.1255 65.669 38.8146Z",
    fill: "#B9CED2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0477 41.4469L63.1068 57.786H61.1555V39.0025C61.1555 32.8073 56.169 27.7997 50.0098 27.7997C43.8506 27.7997 38.864 33.0844 38.864 39.2796V57.786H36.7551L36.696 41.2391C36.5186 31.2634 42.8946 25.9688 50.0591 25.9688C57.2136 25.949 63.6291 31.0061 63.0477 41.4469Z",
    fill: "#A0B9C1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2245 57.7763V38.9928C61.2245 32.7976 56.238 27.79 50.0788 27.79H50.0591V25.9492C50.0788 25.9492 50.1084 25.9492 50.1182 25.9492C57.2629 25.9492 63.6882 30.9865 63.0969 41.4372L63.1561 57.7763H61.2048H61.2245Z",
    fill: "#87ACB7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3782 75.6743H35.6713C33.1091 75.6743 31.0396 73.5862 31.0396 71.023V46.1631C31.0396 43.59 33.1189 41.5117 35.6713 41.5117H64.3684C66.9306 41.5117 69.0001 43.5999 69.0001 46.1631V71.0131C69.01 73.606 66.9405 75.6743 64.3782 75.6743Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9704 46.1329V48.4784C68.9704 45.9053 66.8911 43.827 64.3387 43.827H35.6317C33.0695 43.827 31 45.9152 31 48.4784V46.123C31 43.5499 33.0794 41.4717 35.6317 41.4717H64.3288C66.8911 41.4816 68.9704 43.5697 68.9704 46.1329Z",
    fill: "#E3E6E9"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M68.9704 70.9834V73.3388C68.9704 75.9118 66.8911 77.9901 64.3387 77.9901H35.6317C33.0695 77.9901 31 75.9019 31 73.3388V70.9834C31 73.5565 33.0794 75.6347 35.6317 75.6347H64.3288C66.8911 75.6446 68.9704 73.5565 68.9704 70.9834Z",
    fill: "#AEB5BE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0496 59.84L52.9464 63.8678C53.0252 64.234 52.7394 64.5903 52.3748 64.5903H47.7037C47.3193 64.5903 47.0335 64.234 47.1321 63.8678L48.0289 59.7707C47.0335 59.0483 46.4422 57.831 46.6098 56.495C46.797 54.8917 48.0979 53.5854 49.6943 53.4172C51.823 53.1797 53.6067 54.8423 53.6067 56.9205C53.587 58.1378 52.976 59.2165 52.0496 59.84Z",
    fill: "#42342F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9464 63.888C53.0252 64.2542 52.7394 64.6104 52.3748 64.6104H50.0195V53.4076C51.9905 53.3779 53.587 54.9614 53.587 56.9407C53.587 58.148 52.976 59.2169 52.0496 59.8502L52.9464 63.888Z",
    fill: "#2F241F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6589_20183",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25 8.75) rotate(66.1979) scale(99.7328)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96875,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivatedpincode);
export default __webpack_public_path__ + "static/media/activatedpincode.1e0ec95a9bf4993bf909e29895bd7311.svg";
export { ForwardRef as ReactComponent };